// Shared links always use the stable customer domain, never a preview/Founder URL.
export function publicMenuUrl(slug) {
  return typeof slug === 'string' && slug.trim()
    ? `https://app.ristodaily.com/menu/${encodeURIComponent(slug.trim())}` : '';
}

export const MENU_QR_OPTIONS = {
  type: 'image/png', width: 1024, margin: 4, errorCorrectionLevel: 'M',
  color: { dark: '#000000ff', light: '#ffffffff' },
};

export async function menuQrImage(url) {
  const QRCode = await import('qrcode');
  return QRCode.toDataURL(url, MENU_QR_OPTIONS);
}

export function menuQrFilename(slug) {
  const name = String(slug || '').replace(/[^a-z0-9-]/gi, '-').slice(0, 100);
  return `menu-${name || 'ristorante'}-qr.png`;
}

export function downloadMenuQr(image, filename) {
  const link = document.createElement('a');
  link.href = image;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  link.remove();
}
